import React, { useState, useEffect } from "react";
import { ArrowLeft, ArrowRight, ChevronLeft, ChevronRight } from "lucide-react";
import c1 from "./images/c1.jpg";
import c2 from "./images/c2.jpg";
import c3 from "./images/c3.png";
import c4 from "./images/c4.png";
import c5 from "./images/c5.jpg";
import c6 from "./images/c6.png";
import c7 from "./images/c1.jpg";
import c8 from "./images/c8.png";

const CarouselFood = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [
    {
      id: 1,
      src: c1,
      alt: "Restaurant interior 1",
    },
    {
      id: 2,
      src: c2,
      alt: "Restaurant interior 2",
    },
    {
      id: 3,
      src: c3,
      alt: "Restaurant interior 3",
    },
    {
      id: 4,
      src: c4,
      alt: "Restaurant interior 4",
    },
    {
      id: 5,
      src: c5,
      alt: "Restaurant interior 4",
    },
    {
      id: 6,
      src: c6,
      alt: "Restaurant interior 4",
    },
    {
      id: 7,
      src: c7,
      alt: "Restaurant interior 4",
    },
    {
      id: 8,
      src: c8,
      alt: "Restaurant interior 4",
    },
  ];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  // Auto-scroll effect
  useEffect(() => {
    const autoScroll = setInterval(() => {
      nextSlide();
    }, 6000);

    return () => clearInterval(autoScroll);
  }, [currentIndex]);

  const getVisibleImages = () => {
    const visible = [];
    for (let i = 0; i < 3; i++) {
      const index = (currentIndex + i) % images.length;
      visible.push({ ...images[index], position: i });
    }
    return visible;
  };

  const visibleImages = getVisibleImages();

  // Define sizes and styles for each position
  const getImageStyles = (position) => {
    const styles = {
      0: {
        size: "w-32 h-48 md:w-40 md:h-40",
        zIndex: "z-30",
        margin: "",
        shadow: "shadow-lg",
        border: "border-4 border-white",
      },
      1: {
        size: "w-48 h-54 md:w-60 md:h-60",
        zIndex: "z-20",
        margin: "-ml-8 md:-ml-12 -mt-4 md:-mt-6",
        shadow: "shadow-xl",
        border: "border-4 border-white",
      },
      2: {
        size: "w-64 h-70 md:w-80 md:h-80",
        zIndex: "z-10",
        margin: "-ml-8 md:-ml-12 -mt-6 md:-mt-8",
        shadow: "shadow-2xl",
        border: "border-4 border-white",
      },
    };
    return styles[position] || styles[2];
  };

  return (
    <div className="relative w-full max-w-6xl mx-auto overflow-hidden">
      <div className="relative flex items-center justify-center min-h-[400px] md:min-h-[500px]">
        {/* Images Container */}
        <div className="flex items-center justify-center w-full px-12 h-90 md:h-96 relative">
          {/* Left Navigation Button */}

          <button
            className="absolute left-0 z-40 bg-blue-600 text-white w-12 h-12 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors"
            aria-label="Previous image"
            onClick={prevSlide}
          >
            <ArrowLeft className="w-6 h-6" />
          </button>

          {visibleImages.map((image, index) => {
            const styles = getImageStyles(index);
            return (
              <div
                key={`${image.id}-${index}`}
                className={`relative ${styles.zIndex} ${styles.margin}`}
              >
                <div
                  className={`${styles.size} rounded-lg overflow-hidden ${styles.shadow} ${styles.border}`}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                  />
                </div>
              </div>
            );
          })}

          {/* Right Navigation Button - Close to images */}

          <button
            className="absolute right-0 z-40 bg-blue-600 text-white w-12 h-12 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors"
            aria-label="Previous image"
            onClick={nextSlide}
          >
            <ArrowRight className="w-6 h-6" />
          </button>
        </div>
      </div>

      {/* Dots Indicator */}
      {/* <div className="flex justify-center mt-6 space-x-2">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-3 h-3 rounded-full transition-all duration-200 ${
              index === currentIndex
                ? "bg-blue-600 scale-125"
                : "bg-gray-300 hover:bg-gray-400"
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div> */}
    </div>
  );
};

export default CarouselFood;
